import FooterContent from "./FooterContent";

export default {
  iubenda: {
    siteId: 2457934,
    cookiePolicyId: {
      it: 76641528,
      en: 26289160
    },
  },
  googleTagManager: {
    gtmId: 'GTM-T6BMQ7F'
  },
  pageTitle: 'Rattix MyPage',
  favicon: '/favicon-rattix.ico',
  manifest: '/manifest-rattix.json',
  deeplink: {
    androidIntentPackage: 'io.myair.rattix',
    iosDeeplinkDestination: 'rattix://app.myair.io/',
    appleSlug: 'youmans-drive',
    appleStoreId: '6768297551'
  },
  FooterContent,
  helpDesk: {
    operator: {
      descriptionTranslationKey: 'supportView.helpDesk.operator.description',
      phone: '0381092120',
      whatsapp: '3491233800',
      email: 'info@myair.io',
      faq: 'https://www.myair.io/it/faq-domande-frequenti/',
      formUrl: 'https://share.hsforms.com/1aqr2m159Swe5oOSAiQKePw3csdt',
      axaPhone: '+390547313404'
    }
  }
};
